"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _alloyReactDropdown = require("@adsk/alloy-react-dropdown");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const StyledDropdown = _ref => {
  let {
    items,
    defaultValue,
    onChange,
    disabled = false
  } = _ref;
  const {
    menuProps,
    controlProps
  } = (0, _alloyReactDropdown.useDropdown)({
    items,
    selectedItem: defaultValue,
    onSelectedItemChange: onChange
  });
  return /*#__PURE__*/_react.default.createElement(Container, null, /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.Control, _extends({}, controlProps, {
    disabled: disabled
  })), /*#__PURE__*/_react.default.createElement(_alloyReactDropdown.DropdownMenu, menuProps));
};
StyledDropdown.propTypes = {
  items: _propTypes.default.array,
  defaultValue: _propTypes.default.object,
  onChange: _propTypes.default.func,
  disabled: _propTypes.default.bool
};
const Container = _styledComponents.default.div`
  width: 100%;
  margin-top: 10px;
`;
var _default = exports.default = StyledDropdown;